import { AfterViewInit, Directive, inject, input, InputSignal, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GroupItemModel } from '@libs/form/models';
import { Subscription } from 'rxjs';
import { ConditionalFieldsService, ConditionEvaluatorFactory, StateHandlerFactory } from '../../services';

@Directive({
  selector: '[uiFormConditionalFields]',
  providers: [
    ConditionEvaluatorFactory,
    StateHandlerFactory,
    ConditionalFieldsService,
  ],
})
export class ConditionalFieldsDirective implements AfterViewInit, OnDestroy {
  private subscription?: Subscription;
  private readonly conditionalFieldsService: ConditionalFieldsService = inject(ConditionalFieldsService);

  public formGroup: InputSignal<FormGroup> = input.required();
  public data: InputSignal<GroupItemModel> = input.required();

  public ngAfterViewInit(): void {
    this.subscription = this.conditionalFieldsService.initialize(this.data(), this.formGroup());
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
